import React from 'react';
import PropTypes from 'prop-types';
import { Button } from 'components';

import './info-modal.scss';

export class InfoModal extends React.PureComponent {
  static propTypes = {
    options: PropTypes.object,
    hideModal: PropTypes.func,
  };

  static defaultProps = {
    options: {},
  };

  handleClick = async () => {
    const {
      options: { handleReloadPage, handleSetAccountDataFlag },
      hideModal,
    } = this.props;
    await hideModal();
    handleReloadPage && (await handleReloadPage());
    handleSetAccountDataFlag && handleSetAccountDataFlag();
  };

  render() {
    const { options } = this.props;

    return (
      <div
        className={`white-box info-modal ${options.additionalClassName}`}
        style={options.style}
      >
        {options.icon}
        <div className="mt-8 info-modal__text bold montserrat">
          {options.text}
        </div>
        <div className="mt-1 info-modal__text fs-12">{options.body}</div>
        <Button
          className={`_red ${
            options.additionalClassNameBtn
              ? options.additionalClassNameBtn
              : 'mt-14'
          }`}
          style={{ minWidth: '180px' }}
          onClick={this.handleClick}
        >
          Close
        </Button>
      </div>
    );
  }
}
